import React, { useContext } from 'react';
import classNames from 'classnames';

import SvgIcon from '../../../components/SvgIcon';
import GlobalContext from '../../../utils/GlobalContext';

const testStatusUnsure = 'unsure';
const testStatusValid = 'valid';
const testStatusInvalid = 'invalid';

const iconName = (status) => {
  switch (status) {
    case testStatusUnsure:
      return 'question';
    case testStatusInvalid:
      return 'x';
    case testStatusValid:
      return 'okSmall';
    default:
      return 'incomplete';
  }
};

export default function TestStatus({ status }) {
  const { locales } = useContext(GlobalContext);

  const getStatusLabel = (statusValue) => {
    if (!statusValue) return locales.testing.testCard.statusOptions.incomplete;

    const statusKey = statusValue.toLowerCase();
    return locales.testing.testCard.statusOptions[statusKey] || statusValue;
  };

  const classes = {
    'testing-status--incomplete': !status,
    'testing-status--unsure': status === testStatusUnsure,
    'testing-status--invalid': status === testStatusInvalid,
    'testing-status--valid': status === testStatusValid,
  };

  return (
    <div className={classNames('testing-status', classes)}>
      <div className="testing-status-icon">
        {status ? (
          <SvgIcon name={iconName(status)} />
        ) : (
          <SvgIcon name={iconName('incomplete')} />
        )}
      </div>
      <div className="testing-status-text custom-font-body">
        {getStatusLabel(status)}
      </div>
    </div>
  );
}
